import { render, staticRenderFns } from "./EventControlPanelExtensionDialog.vue?vue&type=template&id=2e68d7ee&scoped=true&"
import script from "./EventControlPanelExtensionDialog.vue?vue&type=script&lang=js&"
export * from "./EventControlPanelExtensionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68d7ee",
  null
  
)

export default component.exports